export * from './ActiveIngredientQuantityStepperText';
